function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.392 6.125a.5.5 0 00-.5.5v6.75a.5.5 0 00.5.5h4.683a.5.5 0 00.5-.5v-6.75a.5.5 0 00-.5-.5h-4.683z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M4.5 4.125A2.125 2.125 0 002.375 6.25v7.5c0 1.174.951 2.125 2.125 2.125h11a2.125 2.125 0 002.125-2.125v-7.5A2.125 2.125 0 0015.5 4.125h-11zM3.625 6.25c0-.483.392-.875.875-.875h11c.483 0 .875.392.875.875v7.5a.875.875 0 01-.875.875h-11a.875.875 0 01-.875-.875v-7.5z"
}));